module.exports = __webpack_public_path__ + "static/img/pr_bg_2.ee933cf8.png";